module.exports = __webpack_public_path__ + "img/plus.5bdc6c3e.svg";